import {AsyncPipe, formatNumber} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core'
import {MatTab, MatTabContent, MatTabGroup} from '@angular/material/tabs'
import {ReplaySubject} from 'rxjs'
import {KalpResult} from '../../model/kalp-result'
import {KalpService, LegacyKalp} from '../../services/kalp.service'
import {KalpDisplayComponent} from '../6b-1-kalp-display/kalp-display.component'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'

export interface KData {
  name: string
  kalp: LegacyKalp
  value: string
}

@Component({
  selector: 'spb-kalp-result',
  templateUrl: './kalp-result.component.html',
  styleUrls: ['./kalp-result.component.scss'],
  imports: [
    MatTabGroup,
    MatTab,
    MatTabContent,
    KalpDisplayComponent,
    AsyncPipe
  ]
})
export class KalpResultComponent implements OnInit {
  public kalpService = inject(KalpService)

  public kalps$ = new ReplaySubject<KData[]>(1)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()

  public ngOnInit(): void {
    this.kalpService.kalpResult$
      .pipe(this.takeUntilDestroyed())
      .subscribe(kalps => {
        this.kalps$.next(
          kalps.map((kalp: LegacyKalp) => {
            const kalpResult = new KalpResult(kalp)
            return {
              name: kalp.name,
              kalp,
              value: formatNumber(kalpResult.kalp, 'sv', '1.0-0')
            }
          }))
      })
  }
}
